module.exports = __webpack_public_path__ + "static/media/et.2c1adbb5.svg";